import axios from 'config/axios';
import { ApiFunusPermission } from './types';

export const permission: ApiFunusPermission = {
  getAllPermissionGroupList: () => axios.get(`/permission`),
  getPermissionGroupListByRole: (idRole) => axios.get(`/permission/${idRole}`),
};
